import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { ENV_CONFIG, EnvironmentConfig } from 'src/app/core/enviroment-config';
import { CrudApiService } from 'src/app/core/service/abstract/rest-api.service';
import { PortalGroup } from 'src/app/data/model/portal-group';
import { ApiModule } from '../api.module';

@Injectable({
  providedIn: ApiModule,
})
export class PortalGroupApiService extends CrudApiService<PortalGroup> {
  constructor(http: HttpClient, @Inject(ENV_CONFIG) config: EnvironmentConfig) {
    super('management/group', http, config);
  }
}
